import { Link } from "react-router-dom";
import { Figure } from "../Figure";
import { ROUTES } from "../../lib/routes";
import { VISITS, getVisit, visitsByHonour } from "../../lib/visits";

/**
 * Four of the twenty, in the source's own rank order — the two Bharat Ratnas
 * first, then the visits with the widest recognition. Resolved by slug so the
 * catalogue stays the single source and a removed entry fails the build.
 */
const TILES = ["apj-abdul-kalam", "c-n-r-rao", "g-madhavan-nair", "a-s-kiran-kumar"].map(
  (s) => getVisit(s)!,
);

/** The honour ladder, counted off the catalogue rather than typed in. */
const TALLY = visitsByHonour().map((t) => ({ label: t.label, n: t.visits.length }));

export function VisitorsStrip() {
  return (
    <section className="section visitors-section">
      <div className="container">
        <div className="visitors-grid">
          <div className="visitors-intro">
            <div className="kicker">Who has visited</div>
            <h2>Prominent guests visiting the institute.</h2>
            <p>
              A President of India, two Bharat Ratnas, the people who have run ISRO and the DRDO —
              received here, and photographed in the institute's own record.
            </p>
            <ol className="visitors-tally">
              {TALLY.map((t) => (
                <li key={t.label}>
                  <span className="n">{String(t.n).padStart(2, "0")}</span>
                  <span className="t">{t.label}</span>
                </li>
              ))}
            </ol>
            <Link className="btn-link visitors-all" to={ROUTES.visitors}>
              All {VISITS.length} visitors <span className="arr">→</span>
            </Link>
          </div>

          {/* 3/2, in two rows. Every photograph in this set is a landscape
              group shot; a portrait tile cropped the room out of them. */}
          <div className="visitors-tiles">
            {TILES.map((v) => (
              <Link key={v.slug} to={ROUTES.visitors} className="visitor-tile reveal">
                <Figure
                  media={v.photos[0]}
                  fallbackLabel={v.name.toUpperCase()}
                  aspect="3/2"
                  sizes="(max-width: 900px) 45vw, 330px"
                />
                <div className="visitor-tile-name">{v.name}</div>
                <div className="visitor-tile-honour">{v.honour ?? v.affiliation}</div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
